import { createSlice } from '@reduxjs/toolkit';

import history from 'config/history';

import { getErrors } from 'helpers/error-helpers';
import { localizeWithCurrentUrl } from 'helpers/locales';

import api from 'api';

export const initialForgotPasswordState = {
  isLoading: false,
  error: null,
};

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState: initialForgotPasswordState,
  reducers: {
    forgotPasswordLoading: (state) => {
      state.isLoading = true;
    },
    forgotPasswordSuccess: (state) => {
      state.isLoading = false;
    },
    forgotPasswordError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { forgotPasswordLoading, forgotPasswordSuccess, forgotPasswordError } =
  forgotPasswordSlice.actions;

// SIDE EFFECTS
export function forgotPassword({ email }) {
  return (dispatch) => {
    dispatch(forgotPasswordLoading());

    return api.auth
      .recoverPassword(email)
      .then((res) => {
        dispatch(forgotPasswordSuccess(res));

        const localizedUrl = localizeWithCurrentUrl(
          '/forgot-password/confirmation',
        );

        history.push(localizedUrl);
      })
      .catch((err) => {
        dispatch(forgotPasswordError(getErrors(err)));
      });
  };
}

export default forgotPasswordSlice.reducer;
